import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '@core/services/auth.service';
import { environment } from '../../../environments/environment';

/** Rutas que no llevan token ni deben disparar un refresh al fallar con 401. */
const PUBLIC_ACCOUNT_PATHS = ['/account/login', '/account/refresh', '/account/register'];

const withToken = (req: HttpRequest<unknown>, token: string) =>
  req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });

/**
 * Agrega el token de la cuenta a las llamadas a nuestra API (nunca a terceros) y,
 * ante un 401, renueva el token una vez y reintenta. Si el refresh falla, la sesión
 * ya quedó cerrada en AuthService y el error sigue hacia la vista.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.accessToken();
  if (!token || !req.url.startsWith(environment.apiUrl) || PUBLIC_ACCOUNT_PATHS.some((p) => req.url.endsWith(p))) {
    return next(req);
  }

  return next(withToken(req, token)).pipe(
    catchError((err) => {
      if (!(err instanceof HttpErrorResponse) || err.status !== 401) return throwError(() => err);
      return auth.refresh().pipe(
        catchError(() => throwError(() => err)),
        switchMap((fresh) => next(withToken(req, fresh))),
      );
    }),
  );
};
